// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts";
import styled from "styled-components";

export const ModalContentContainer = styled.div`
    display:flex;
    flex-direction: column;
    margin: 0px 20px;
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    font-family: ${dgFontFamily};
`